import * as requestFromServer from './completeDetailsCrud';
import {
  completeDetailsSlice,
  callTypes
} from './completeDetailsSlice';
import {showProgressBarPopUp} from '../../_common/actions/progressBarPopUp/showProgressBarPopUp';
import {hideProgressBarPopUp} from '../../_common/actions/progressBarPopUp/hideProgressBarPopUp';
import {messages as M} from '../../../../_metronic/i18n/messages';

const {actions} = completeDetailsSlice;

export const uploadFileAction = (file, year) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  dispatch(showProgressBarPopUp(M.UPLOADING_FILE));

  const formData = new FormData();
  formData.set('content', file);
  formData.set('year', year);

  const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  return requestFromServer
    .uploadFile({formData})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();
      const filteredData = data.filter(item => item.receiveNotifications !== false)

      dispatch(actions.completeDetailsFetched({
        entities: filteredData
      }));
    })
    .then(() => delay(2000))
    .then(() => {
        dispatch(hideProgressBarPopUp())
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't upload file!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
      dispatch(hideProgressBarPopUp());
    });
};
